export { default } from './SnackbarContent';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/SnackbarContent/index.js
// module id = 413
// module chunks = 2